import { threeDSService } from '@afterpaytouch/portal-api/consumer/threeDS'

export const { useFinaliseThreeDSMutation, useInitiateThreeDSMutation } = threeDSService
